import {BACKEND} from "../config/backend";
import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";

export const VOUCHER_BASE_URL = `${BACKEND}/api/v1/voucher`

export const getVoucherByVouchNo = ({voucherNo}) => {
    return axiosPrivate.get(`${VOUCHER_BASE_URL}/${voucherNo}`, {
        ...standardRequestConfig
    })
}

export const getVoucherListByDatOutVonBis = ({datOutVon, datOutBis}) => {
    return axiosPrivate.get(`${VOUCHER_BASE_URL}/list`, {
        ...standardRequestConfig
        , params: {datOutVon, datOutBis}
    })
}

export const getVouchInListByDatOutVonBis = ({datInVon, datInBis}) => {
    return axiosPrivate.get(`${VOUCHER_BASE_URL}/vouchin/list`, {
        ...standardRequestConfig
        , params: {datInVon, datInBis}
    })
}

export const updateVoucher = ({voucher}) => {
    return axiosPrivate.put(`${VOUCHER_BASE_URL}`, voucher,{
        ...standardRequestConfig
    })
}

export const insertVoucher = ({voucher}) => {
    return axiosPrivate.post(`${VOUCHER_BASE_URL}`, voucher,{
        ...standardRequestConfig
    })
}